import MerchantProfilePicture from "@components/MerchantProfilePicture/MerchantProfilePicture"
import { MerchantInformationDisplay as BaseMerchantInformationDisplay } from '@jagad/ui'

const MerchantInformationDisplay = (
    props: React.ComponentProps<typeof BaseMerchantInformationDisplay>
) => (
    <BaseMerchantInformationDisplay
        {...props}
        profilePicture={(picProps) => (
            <MerchantProfilePicture {...picProps} />
        )}
    />
)

export default MerchantInformationDisplay
